"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfFieldInfo = void 0;
var RtfFieldInfo = (function () {
    function RtfFieldInfo() {
        this.startPos = -1;
        this.separatorPos = -1;
        this.endPos = -1;
        this.locked = false;
        this.isHyperlink = false;
        this.isShapeField = false;
        this.isCodeView = false;
        this.insertInstructionBeforeFieldCode = false;
        this.instruction = '';
    }
    return RtfFieldInfo;
}());
exports.RtfFieldInfo = RtfFieldInfo;
